<template>
    <div class="base">
        <input :data-model="field.model"
                    type="text"
                    :class="full_class"
                    :readonly="field.readonly"
                    :data-idx="field_idx"
                    :value="initial_value"
                    :required="field.required"
                    :disabled="field.disabled"
                    :data-original-title="field.help"
                    data-placement="bottom"
                    data-toggle="tooltip"
                    :placeholder="field.placeholder">
            <span class="input-group-addon input-icon" style="height: 35px;width: 35px;" @click="showDp">
                <i class="fa fa-calendar input-margin"></i>
            </span>
    </div>
</template>

<script>
export default {
    name: "CustomDatepicker",
    props: ["field", "value", "field_idx", "start_date"],
    data() {
        return {
            initial_value: null,
            // current_value:null,
            final_value: null,
            full_class: [],
        }
    },
    mounted() {
        this.initial_value = this.value ? moment(this.value, "YYYY-MM-DD").format("DD/MM/YYYY") : null
        this.final_value = this.initial_value == 'Invalid date' ? null : this.initial_value
        // this.current_value = this.value
        this.full_class = ["form-control", "date-time-field-" + this.field_idx, "tip", "input-value-center"]
        this.$nextTick(() => {
            $('.date-time-field-' + this.field_idx).datepicker({
                language: "fr",
                autoclose: true,
                title: this.field.label,
                startDate: this.start_date || ''
            }).on('changeDate', (e) => {
                if (e.date != null) {
                    this.final_value = moment(e.date).format("DD/MM/YYYY")
                    this.initial_value = this.final_value
                } else {
                    this.final_value = null
                    this.initial_value = null
                }
                console.warn("date updated")
            })
        })
    },
    methods: {
        showDp() {
            $('.date-time-field-' + this.field_idx).focus()
        }
    },
    watch: {
        final_value: function () {
            this.$emit("field-updated", {
                type: this.field.type,
                idx: this.field_idx,
                new_value: this.final_value
            })
        }
    }
}
</script>

<style scoped>
.base {
    display: flex;
    align-items: center;
}

.input-value-center {
    text-align: center;
}

.input-icon {
    display: flex;
    align-items: center;
}

.input-margin {
    margin-left: auto;
    margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Datepicker.vue